import React from "react";
import FingerTabs from "../modules/FingerLimits/FingerTabs";
export default function DutiesPage() {
  return <FingerTabs />;
}
